import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: "快速导航",
      links: [
        { label: t("nav.home"), to: "/" },
        { label: t("nav.categories"), to: "/category/platform" },
        { label: "最新资讯", to: "/category/promotions" },
        { label: t("nav.about"), to: "/about" },
      ],
    },
    {
      title: "服务支持",
      links: [
        { label: "帮助中心", to: "/about" },
        { label: "常见问题", to: "/about" },
        { label: "联系方式", to: "/about" },
        { label: "意见反馈", to: "/about" },
      ],
    },
    {
      title: "法律信息",
      links: [
        { label: t("footer.terms"), to: "/about" },
        { label: t("footer.privacy"), to: "/about" },
        { label: t("footer.disclaimer"), to: "/about" },
        { label: "Cookie政策", to: "/about" },
      ],
    },
  ];

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-vip-crown-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                必赢国际
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              必赢国际是备受信赖的国际化综合平台，提供安全、公正、多元的优质服务体验。我们致力于为全球用户打造值得信赖的一站式服务平台。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            {t("footer.copyright").replace("2026", String(currentYear))}
          </p>
          <div className="flex items-center gap-4">
            <a href="https://www.facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-background-200 hover:bg-background-700 transition-colors">
              <i className="ri-facebook-fill"></i>
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-background-200 hover:bg-background-700 transition-colors">
              <i className="ri-twitter-x-line"></i>
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-background-200 hover:bg-background-700 transition-colors">
              <i className="ri-instagram-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}